<template>
    <el-select :value="value" class="select" clearable filterable :placeholder="$t('shared.pleaseSelectEquipment')" :loading="loading" @change="change">
        <el-option v-for="item in equipmentList" :key="item.id" :label="buildFromItem(item)" :value="item.id"></el-option>
    </el-select>
</template>

<script>
    import api from './api'
    export default {
        name: 'equipment-selector',
        props: {
            value: {},
            customerId: {
                type: Number,
                default: undefined
            }
        },
        data() {
            return {
                loading: false,
                equipmentList: []
            }
        },
        watch: {
            customerId: function (val) {
                if (!val) {
                    this.equipmentList = []
                } else {
                    this.loading = true
                    api.getEquipment(this.customerId).then(response => {
                        this.loading = false
                        this.equipmentList = response.data
                    })
                }
            }
        },
        methods: {
            buildFromItem(item) {
                return `${item.model} (${item.serialNumber})`
            },
            change(val) {
                this.$emit('input', val)

                var equipment = val ? this.equipmentList.find(p => p.id === val) : undefined;
                this.$emit('equipmentSelected', equipment)
            }
        }
    }
</script>

<style scoped>
    .select {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/shared/components/equipmentselector/EquipmentSelector.vue